import React from 'react';
import CheckboxFieldGroup from 'components/CheckboxFieldGroup';
import useOptions from '../../hooks/useOptions';

import './UnacceptableOptionsField.styles.scss';
import './UnacceptableOptionsField.styles.responsive.scss';

const UnacceptableOptionsField: React.FC = () => {
  const { consideredAspectsOfDealOptions } = useOptions();

  return (
    <div className="unacceptable-options-field">
      <CheckboxFieldGroup
        name="consideredAspectsOfDeal"
        options={consideredAspectsOfDealOptions}
        styled
      />
    </div>
  );
};

export default UnacceptableOptionsField;
